import { useMutation } from '@tanstack/react-query';

import { verificationKeys } from './keys';
import { useApi } from '../../ApiClient';
import { EChannel, EVerificationStatus } from '../components/types';

export interface IRequestCodeArgs {
  to: string;
  channel: EChannel;
}

interface IRequestCodeResponse {
  sid: string;
  to: string;
  channel: EChannel;
  status: EVerificationStatus;
  dateCreated: string;
  dateUpdated: string;
}

export const useRequestCode = (monolithBaseUrl: string) => {
  const apiClient = useApi();

  return useMutation<
    IRequestCodeResponse | undefined,
    unknown,
    IRequestCodeArgs
  >({
    mutationKey: verificationKeys.requestCode,
    mutationFn: async (args): Promise<IRequestCodeResponse | undefined> => {
      const data = await apiClient?.post<IRequestCodeResponse>(
        `${monolithBaseUrl}/api/mfa/v1/verify`,
        args
      );
      return data;
    },
  });
};
